import { HeaderSearch, Overlay, Portal } from 'ui/components';
import { HeaderSearchResult } from '../HeaderSearchResult';
import { useHeaderSearch } from './hooks/useHeaderSearch';
import HeaderSearchInput from '../HeaderSearchInput/HeaderSearchInput';
import { Utilities } from 'core';

const HeaderSearchWidget = () => {
  const {
    searchValue,
    handleChange,
    handleClearSearch,
    handleFocus,
    handleSearchClick,
    focus,
    handleFocusOverlay,
    statusPreview,
  } = useHeaderSearch();

  return (
    <HeaderSearch.Wrapper>
      <Portal>
        <Overlay onClick={handleFocusOverlay} visible={focus} />
      </Portal>
      <HeaderSearchInput
        handleChange={handleChange}
        handleClear={handleClearSearch}
        onSearchClick={handleSearchClick}
        onFocus={handleFocus}
        searchValue={searchValue}
        placeholder="Busque produtos por nome ou código"
      />
      {statusPreview !== Utilities.STATUS.IDLE && (
        <HeaderSearchResult
          query={searchValue}
          focus={focus}
          handleClearSearch={handleClearSearch}
        />
      )}
    </HeaderSearch.Wrapper>
  );
};

export default HeaderSearchWidget;
